import { render } from "./NameEN.vue?vue&type=template&id=82f82f5a"
import script from "./NameEN.vue?vue&type=script&lang=js"
export * from "./NameEN.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__